import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const UserPlaceholderAvatar = () => ___EmotionJSX("svg", {
  height: "28",
  viewBox: "0 0 62 62",
  width: "28",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, ___EmotionJSX("defs", null, ___EmotionJSX("circle", {
  cx: "31",
  cy: "31",
  id: "a",
  r: "31"
})), ___EmotionJSX("g", {
  fill: "none",
  fillRule: "evenodd"
}, ___EmotionJSX("mask", {
  fill: "#fff",
  id: "b"
}, ___EmotionJSX("use", {
  xlinkHref: "#a"
})), ___EmotionJSX("use", {
  fill: "#7933FF",
  xlinkHref: "#a"
}), ___EmotionJSX("path", {
  d: "M25.763886 22L77 51.576225 13.236114 162 -38 132.423775z",
  fill: "#03EF62",
  mask: "url(#b)"
}), ___EmotionJSX("path", {
  d: "M73.948-12L97 1.398 49.052 85 26 71.603 73.948-12z",
  fill: "#00C53B",
  mask: "url(#b)"
})));